import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import activityLogRoutes from 'modules/activityLog/common/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const OnboardAssessmentLogDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityLogOnboardAssessmentLogDetails" */ 'modules/activityLog/details/OnboardAssessmentLogDetails/pages/OnboardAssessmentLogDetails'
    )
)

const OnboardAssessmentLogDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route exact path={`${routes.root}/:assessmentId`} component={OnboardAssessmentLogDetails} />
      <Redirect path='*' to={activityLogRoutes.root} />
    </Switch>
  </Suspense>
)

export default OnboardAssessmentLogDetailsRouting
